import { Module } from 'vuex';
import { CartCreditState } from '../types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { RootState } from '@/store/types';

const cartCredit: Module<CartCreditState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,    
};

export default cartCredit;